<template>
  <div>
    <div
      class="help-button card pc-only unselectable"
      style="padding: 0"
    >


      <div
        v-clickoutside="handleClickOutside"
        class="u-button-list"
        style="font-size: 0.9em;"
      >

      <a class="u-button-big popover">
          <img class = "live-chat-logo"
            :src="OSS + 'static/' + 'contact_live.png'"
          >
          <div class="qr-fixed card">
            <img
              src="../assets/Ruanyangyang.jpg"
              width="150"
            >
          </div>
        </a> 
        <span class="u-botton_line"></span>

        <div
          v-if="school"
          class="help-hover"
        >     
          <img
            class="school-logo"
            :src="OSS + 'school_images/' + camelize(school.name) + 'Logo'"
          >
          <div class="card addi-container">
            <p>当前学校: {{ school.name }}</p>
            <i-button
              style="margin-top: 0.5em;"
              type="ghost"
              size="small"
              @click="setSchool(null)"
            >
              更改学校
            </i-button>
          </div>
        </div>
        <span class="u-botton_line"></span>
        <a
          v-for="type in keys(types)"
          class="u-button"
          @click="jump(type)"
        >{{ types[type] }}</a>
        <span class="u-botton_line"></span>
        <a class="u-button popover">APP
          <div class="qr-fixed card">
            <img
              src="../assets/qr-app.gif"
              width="150"
            >
          </div></a>
        <a class="u-button popover">公众号
          <div class="qr-fixed card">
            <img
              src="../assets/qr-wx.jpg"
              width="150"
            >
          </div></a>
        <a class="u-button popover">小程序
          <div class="qr-fixed card">
            <img
              src="../assets/qr-wxapp-circle.jpg"
              width="150"
            >
          </div></a>
        <span class="u-botton_line"></span>
        <!-- <a href="#top" class="u-button"><Icon type="ios-arrow-up"></Icon></a> -->
        <a
          class="u-button"
          @click="jumpTop()"
        ><Icon type="ios-arrow-up"></Icon></a>
      </div>
    </div>

    <div class="w3-content w3-margin-top index-header pc-only">
      <div class="card">
        <img src="../assets/index-header.gif">
        <a
          class="btn left"
          href="https://itunes.apple.com/us/app/umiuni/id1265697567?mt=8"
          target="_blank"
        ></a>
        <div class="btn right wechat">
          <div class="qr-fixed card">
            <img
              src="../assets/qr-wxapp-circle.jpg"
              width="150"
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="mobile-only"
      style="overflow: hidden; height: 4.6em;"
    >
    </div>

    <div
      class="w3-content w3-margin-top header-outer"
      style="overflow: hidden;"
    >
      <Row class="card header">
        <i-col
          span="24"
          class="header-inner"
        >
          <Carousel
            v-if="slideList"
            class="slide"
            autoplay
            :autoplay-speed="6000"
          >
            <Carousel-item
              v-for="slide in slideList"
              :key="slide.title"
            >
              <a
                class="slide-item pc-only"
                :style="{ 
                  'background-size': `cover`,
                  'background-image': `url(${OSS + slide.image})` 
                }"                
                :href="slide.link"
              >
                <div class="title">{{ slide.title }}</div>
              </a>
              <a
                class="slide-item mobile-only"
                :style="{                   
                  'background-size': `contain`,
                  'background-image': `url(${OSS + slide.image})` ,
                }"
                :href="slide.link"
              >
                <div class="title">{{ slide.title }}</div>
              </a>
            </Carousel-item>
          </Carousel>
        </i-col>
      </Row>
    </div>

    <div
      v-for="type in keys(types)"
      :id="`type-${type}`"
      :key="type"
      class="w3-content content unselectable"
    >
      <Row class="type-info card">
        <h4>
          <Icon
            type="aperture"
            style="color:#fa6300"
          ></Icon>&nbsp;&nbsp;{{ types[type] }}
        </h4>

        <div
          v-if="tagList"
          class="tag-list pc-only"
        >
          <a
            v-for="tag in tagList[type]"
            :key="tag"
            v-link="{ name: 'search', query: { 'type': type, 'tag': tag } }"
          >
            {{ tag }}
          </a>
        </div>

        <Dropdown
          v-if="tagList"
          class="mobile-only"
          trigger="click"
        >
          <a href="javascript:void(0)">
            <h4 style="margin-left:5px"><Icon type="navicon"></Icon></h4>
          </a>
          <Dropdown-menu
            slot="list"
            class="dropmenu"
          >
            <Dropdown-item
              v-for="tag in tagList[type]"
              :key="tag"
              class="dropitem"
            >
              <a v-link="{ name: 'search', query: { 'type': item, 'tag': tag } }">{{ tag }}</a>
            </Dropdown-item>
          </Dropdown-menu>
        </Dropdown>

        <i-button
          v-link="{ name: 'search', query: { 'type': type } }"
          class="button"
          type="text"
        >
          更多&nbsp;&nbsp;<Icon
            style="color:#fa6300"
            type="ios-arrow-right"
          ></Icon>
        </i-button>
      </Row>
      <div class="pc-only">
        <item-list
          v-if="type === 'used'"
          :list="usedList"
        ></item-list>
        <item-list
          v-if="type === 'merchant_house'"
          :list="merchantHouseList"
        ></item-list>
        <item-list
          v-if="type === 'car'"
          :list="carList"
        ></item-list>
        <item-list
          v-if="type === 'house'"
          :list="houseList"
        ></item-list>
        <item-list
          v-if="type === 'event'"
          :list="eventList"
        ></item-list>
      </div>
      <Row
        v-if="ad && ad[$index]"
        class="card ad-0"
      >
        <a
          :href="ad[$index].link"
          target="_blank"
        ><img :src="OSS + ad[$index].image"></a>
      </Row>
    </div>
  </div>
</template>

<script>
import api from '../api';
import itemList from './itemList';
import store from '../vuex/store';
import { scrollPosition } from '../utils/scroll';
import { getSchool, getTypes } from '../vuex/getters';
import { setSchool } from '../vuex/actions';
import clickoutside from '../directives/clickoutside';
import { camelize } from '../utils/camelize';
import router from '../router';

export default {
  directives: { clickoutside },

  store,
  vuex: {
    actions: {
      setSchool,
    },
    getters: {
      school: getSchool,
      types: getTypes,
    }
  },

  components: { itemList },

  data () {
    return {
      OSS: api.OSS,

      slideList: null,

      subjectList: [],
      tagList: null,

      usedList: null,
      eventList: null,
      carList: null,
      houseList: null,
      merchantHouseList: null,

      visible: false,
      query: {
        type: 'used',
        school_id: '',
        subject_id: '',
        course: '',
        name: '',
        bedroom: '',
        year: '', // and later
        price: '' // max
      },
      wxToggle: false,
      wxappToggle: false,

      topicList: null,

      ad: [],
    };
  },

  watch: {
    school: {
      deep: true,
      handler: function (to) {
        if (to && to.id) {
          this.$nextTick(() => {
            this.getSlideList();
            this.getAdList();
            this.getTopicList();
            this.clearQuery('used');
            this.fetchItems('used', 5);
            this.fetchItems('car', 5);
            this.fetchItems('event', 5);
            this.fetchItems('house', 5);
            this.fetchItems('merchantHouse', 15, 'merchant_house');
          });
        }
      },
    },
  },

  methods: {
    camelize,

    keys: Object.keys,

    getSlideList () {
      if (!this.school) return;
      this.$http
        .get(api.slide.list, { params: {
          role: 'INDEX_HEADER',
          school_id: this.school ? this.school.id : 0,
        } })
        .then(({ body }) => {
          this.slideList = body;
        });
    },

    fetchItems (type, limit, _type) {
      if (!this.school) return;
      this.$http.get(api.item.list, {
        params: Object.assign({
          type: _type || type,
          sort: 'time_desc',
          limit: limit || 10,
          school_id: this.school.id,
        }),
      })
        .then((res) => {
          this.$set(`${type}List`, res.body.items);
        });
    },

    getTopicList () {
      if (!this.school) return;
      this.$http
        .get(api.forum.topic.list, { params: {
          school_id: this.school.id,
          offset: 0,
          limit: 20,
          sort: 'time_desc',
        } })
        .then(({ body }) => {
          this.topicList = body.topics;
        });
    },

    getAdList () {
      if (!this.school) return;
      this.$http
        .get(api.slide.list, { params: {
          role: 'INDEX_AD_0',
          school_id: this.school ? this.school.id : 0,
        } })
        .then(({ body }) => {
          // console.log(body);
          this.$set('ad[0]', body[0]);
        });
    },

    getTagList () {
      this.$http.get(api.tag.list)
        .then((res) => {
          if (res.body) {
            this.tagList = res.body;
          }
        });
    },

    clearQuery (atype) {
      this.query.type = atype;
      // this.query.school_id = '';
      this.query.subject_id = '';
      this.query.course = '';
      this.query.name = '';
      this.query.bedroom = '';
      this.query.year = '';
      this.query.price = '';
    },

    compressQuery (query) {
      var newQuery = {};
      for (const key in query) {
        if (!query.hasOwnProperty(key)) continue;
        if (!query[key]) continue;
        newQuery[key] = query[key];
      }
      return newQuery;
    },

    jump (type) {
      var obj = document.getElementById(`type-${type}`);
      scrollPosition(obj);
    },

    jumpTop () {
      scrollPosition(null);
    },

    handleOpen () {
      this.visible = !this.visible;
    },

    handleClickOutside () {
      this.wxappToggle = this.wxToggle = false;
    },

    openQr (obj) {
      this.wxappToggle = this.wxToggle = false;
      this.$set(obj, true);
    },

    async setSchoolBaseOnUrl () {
      if (this.$route.params && this.$route.params.schoolAbbr) {
        const schoolAbbr = this.$route.params.schoolAbbr;
        if (schoolAbbr !== this.school.abbr) {
          const res = await this.$http.get(api.school.list);
          const schools = res.body.school;
          _.each(schools, school => { school.key = _.toLower(school.abbr); });
          const school = _.find(schools, { key: _.toLower(schoolAbbr) });
          if (school) {
            await this.setSchool(school);
          } else {
            router.go({ name: 'not-found' });
          }
        }
      }
    },
  },

  attached () {
    this.setSchoolBaseOnUrl();
    this.$nextTick(() => {
      this.getTagList();
      this.getSlideList();
      this.getAdList();
      this.getTopicList();
      this.clearQuery('used');
      this.fetchItems('used', 10);
      this.fetchItems('car', 10);
      this.fetchItems('event', 10);
      this.fetchItems('house', 15);
      this.fetchItems('merchantHouse', 15, 'merchant_house');
    });
  },
};
</script>

<style scoped lang="less">
@import '../styles/const.less';

.help-button {
    position: fixed;
    top: 140px;
    left: 50%;
    margin-left: 540px;

    transition: top .3s;

    z-index: 100;

    @media screen and (max-width: 1000px) {
        display: none;
    }
}
.tablink {
    &.active {
        background: darken(#39f, 10%);
    }
}

.w3-content {
    max-width: @centent-width;
    width: 100%;
}

.index-header {
    & > .card {
        padding: 0;
        overflow: hidden;
        position: relative;
    }
    img {
        width: 100%;
        display: block;
        margin: 0;
    }
    .btn {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        &.left {
            left: 0;
        }
        &.right {
            left: 50%;
        }
        .qr-fixed {
            z-index: 1;
            margin: 50px 0 0 0;
        }
        &.wechat {
            &:hover {
                .qr-fixed {
                    display: block;
                }
            }
        }

        cursor: pointer;
    }
    margin: 7px auto -13px auto !important;
}

.content {
    h4 {
        display: inline-block;
    }
    .button {
        float: right;
    }

    & > * {
        margin: 10px 0;
    }
}

.w3-navbar {
    @media screen and (max-width: 767px) {
        text-align: left;
        .padding {
            display: block;
            width: 140px;

            margin: 0 auto;

            & > * {
                display: inline-block;
                text-align: center;
            }
            & > i {
                width: 30px;
            }
            & > span {
                width: 140px - 30px;
            }
        }
    }
}

.u-button-list {
    text-align: center;
    .school-logo {
        width: 60px;
        margin: 10px;
        text-align: center;
        display: inline-block;
    }
    .live-chat-logo {
        width: 60px;
        text-align: center;
        display: inline-block;
    }

    .help-hover {
        position: relative;

        .addi-container {
            display: none;
            position: absolute;
            right: 80px;
            left: -300px;
            min-height: 85px;
            overflow: hidden;
            top: 0;
            background: #fff;
            padding: 10px;
            margin: 0;

            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:hover {
            .addi-container {
                display: block;
            }
        }
    }

    & > .u-button {
        display: block;
        width: 100%;

        border-radius: 0;

        margin: 0 !important;

        &:not(:last-child) {
            border-bottom: 0 !important;
        }

        &:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        &:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }

    .u-button {
        background: #fff;

        @button-margin: 3px;

        text-align: center;

        height: 36px - 2 * @button-margin;
        // margin: @button-margin;
        padding: 0 5px;
        line-height: 36px - 2 * @button-margin;
        // border: solid 1px @primary-color;
        // border-radius: 4px;
        cursor: pointer;
        outline: none;
        font-weight: 400;

        color: #9ea7b4;
        &.orange {
            color: @primary-color;
        }

        &:hover {
            background: #f5f7f9;
            color: @primary-color;
            &.orange {
                background: @primary-color;
                color: #fff;
            }
        }

        &.popover {
            &:hover {
                .qr-fixed {
                    display: block;
                }
            }
        }
    }

    .u-button-big {
        background: #fff;

        @button-margin: 3px;

        text-align: center;

        height: 60px ;
        // margin: @button-margin;
        padding: 0 5px;
        line-height: 60px - 2 * @button-margin;
        // border: solid 1px @primary-color;
        // border-radius: 4px;
        cursor: pointer;
        outline: none;
        font-weight: 400;

        color: #9ea7b4;
        &.orange {
            color: @primary-color;
        }

        &:hover {
            background: #fff;
            color: @primary-color;
            &.orange {
                background: @primary-color;
                color: #fff;
            }
        }

        &.popover {
            &:hover {
                .qr-fixed {
                    display: block;
                }
            }
        }
    }
}

.w3-image {
    @media screen and (max-width: 767px) {
        display: none;
    }
}

.content {
    margin-bottom: 30px;
    @media screen and (max-width: 769px) {
        margin-bottom: 20px;
    }
}

.type-info {
    @height: 40px;
    height: @height;

    padding: 0 0 0 10px;

    background: #fff;
    line-height: 40px;
    margin: 3px;
    @media screen and (min-width: 769px) {
        margin: 5px;
    }

    border-radius: 4px;

    h4 {
        font-size: 1.1em;
        @media screen and (min-width: 769px) {
            font-size: 16px;
        }
    }

    & > * {
        display: inline-block;
    }

    .tag-list {

        margin-left: 10px;

        // padding: 0 0 2px;

        & > * {
            font-size: 1em;
        }

        a {
            padding: 0 4px;
            color: #9ea7b4;

            border-radius: 2px;

            &:hover {
                // background: #464c5b;
                color: @primary-color;
            }
        }
    }

    .button {
        height: 100%;
    }
}

.header-outer {
    @media screen and (max-width: 769px) {
        margin-top: 0 !important;
    }
}

.header, .header .slide, .header .slide-item, .forum, .forum .topic-container {
    height: 300px;
    @media screen and (max-width: 769px) {
        height: 200px;
    }
}

.header {
    padding: 0;
    margin: 5px;

    overflow: hidden;

    & > * {
        padding: 0;
        margin: 0;

        position: relative;

        height: 100%;
    }

    .slide .slide-item {
        display: block;

        background-position: center;
        background-repeat: no-repeat;

        position: relative;

        cursor: pointer;

        .title {
            width: 100%;
            position: absolute;
            bottom: 0;

            padding: 0.5em 0.5em 1em 0.5em;

            transition: padding .3s;

            color: #fff;
            font-size: 1.4em;
            font-weight: 600;

            background: rgba(0, 0, 0, 0.5);
        }

        /*
        &:hover {
            .title {
                padding-bottom: 1.5em;
            }
        }
        */
    }

    .header-inner {
        @media screen and (max-width: 769px) {
            width: 100%;
        }
    }
}

.dropmenu {
    z-index: 9000;
    .dropitem {
        padding: 0;
        margin: 0;
        height: 30px;
        text-align: center;
        line-height: 30px;
    }
}

.qr-fixed {
    position: fixed;
    margin: -30px 0 0 -170px;

    display: none;
}

.u-botton_line {
    display: block;
    height: 1px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
}

.forum {
    padding-left: 10px;
    .title {
        padding: 0.4em;
        font-size: 1.1em;
        overflow: hidden;

        .main-title {
            font-size: 1.2em;
            font-weight: 600;
            color: @primary-color;
        }

        .more {
            float: right;
            font-size: 0.8em;
            margin: 0.2em 0.4em 0 0;

            transition: margin .3s ease;
        }

        cursor: pointer;
        &:hover {
            .more {
                margin-right: 0;
            }
        }
    }

    .topic-container {
        overflow-y: scroll;
        padding-bottom: 1em;
        font-size: 1em;

        .topic {
            /* border-top: solid 1px #eee; */
            padding: 0.2em 0.4em;
            i.p {
                float: left;
                margin-top: -4px;
                margin-right: 1px;
            }

            .right {
                color: #999;
                font-size: 12px;
                margin-top: 0.1em;
            }

            cursor: pointer;
            &:hover {
                background: #f5f5f5;
            }
        }

    }
}

.ad-0 {
    padding: 0;
    overflow: hidden;
    margin: 5px 5px;
    img {
        width: 100%;
        display: block;
        margin: 0;
    }
}

</style>



// WEBPACK FOOTER //
// Hello.vue?566c0c5e